import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import Spinner from '../../shared/components/Spinner';
import { ROLES } from '../../shared/constant/roles';

// Where a student or teacher still on the login they were given is sent to choose their own.
export const PROFILE_PATHS = {
  [ROLES.STUDENT]: '/student-dashboard/profile',
  [ROLES.TEACHER]: '/dashboard/profile',
};

// `allowWithoutOwnLogin` lets a route through before the account has chosen its own login (the
// inactive-account notice, which an unapproved teacher can't get past anyway).
function RoleGuard({ allowedRoles, allowWithoutOwnLogin = false }) {
  const { user, role, loading, mustChangeLogin, mustChangeLoginLoading } = useAuth();
  const { pathname } = useLocation();

  if (loading || mustChangeLoginLoading) {
    return <Spinner />;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  const profilePath = PROFILE_PATHS[role];
  if (mustChangeLogin && profilePath && !allowWithoutOwnLogin && pathname !== profilePath) {
    return <Navigate to={profilePath} replace />;
  }

  return <Outlet />;
}

export default RoleGuard;
